let isProcessingCartChange = false;

// On /cart page, disable checkout immediately if cart has demo racquets
// but demo fee hasn't been added yet, preventing premature checkout.
(function lockCartCheckoutIfNeeded() {
  if (window.location.pathname !== '/cart') return;

  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const hasDemoRacquet = cart.items.some(item =>
        (item.product_type && item.product_type.toLowerCase().includes('demo')) ||
        (item.properties && item.properties['Demo Rental'])
      );
      const hasDemoFee = cart.items.some(item =>
        (item.handle && item.handle.includes('demo-shipping')) ||
        (item.title && item.title.toLowerCase().includes('demo shipping fee'))
      );

      if (hasDemoRacquet && !hasDemoFee) {
        disableCartCheckout();
      }
    })
    .catch(() => {});
})();

function disableCartCheckout() {
  const selectors = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '[name="checkout"]',
    '.cart__checkout-button',
    '#checkout'
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.demoLocked = 'true';
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.title = 'Adding demo shipping fee...';
    });
  });
}

function enableCartCheckout() {
  document.querySelectorAll('[data-demo-locked="true"]').forEach(btn => {
    btn.removeAttribute('disabled');
    btn.removeAttribute('data-demo-locked');
    btn.style.opacity = '';
    btn.style.cursor = '';
    btn.title = '';
  });
}

/**
 * Intercepts Rebuy's POST to /cart/update.js when it sends updates keyed by
 * the full line item key format ("variantId:hash"). Shopify only accepts
 * variant IDs or a positional array — the hash-suffixed key causes a 422.
 * This fix detects that format and converts to a positional array before
 * the request is sent.
 */
function installCartUpdateFix() {
  if (window._rebuyCartUpdateFixInstalled) return;
  window._rebuyCartUpdateFixInstalled = true;

  const originalFetch = window.fetch;

  window.fetch = function(url, options) {
    if (
      typeof url === 'string' &&
      url.includes('/cart/update.js') &&
      options?.method?.toUpperCase() === 'POST' &&
      options?.body
    ) {
      let body;
      try { body = JSON.parse(options.body); } catch(e) {}

      if (
        body?.updates &&
        typeof body.updates === 'object' &&
        !Array.isArray(body.updates) &&
        Object.keys(body.updates).some(k => k.includes(':'))
      ) {
        // Bad key format detected — convert to positional array using live cart state
        return originalFetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const updatesArray = cart.items.map(item => item.quantity);

            cart.items.forEach((item, index) => {
              // item.key is the full "variantId:hash" — match directly
              if (body.updates[item.key] !== undefined) {
                updatesArray[index] = body.updates[item.key];
              }
            });

            return originalFetch(url, {
              ...options,
              body: JSON.stringify({ updates: updatesArray })
            });
          });
      }
    }

    return originalFetch(url, options);
  };
}

document.addEventListener('DOMContentLoaded', function () {
  let attempts = 0;
  const maxAttempts = 100;
  
  const waitForRebuy = setInterval(function () {
    attempts++;
    
    if (attempts >= maxAttempts) {
      clearInterval(waitForRebuy);
      console.warn("Rebuy failed to load after 20 seconds. Auto-gift feature disabled.");
      enableCartCheckout();
      return;
    }
    
    if (window.Rebuy && window.Rebuy.Cart) {
      const rebuyReady = window.Rebuy._status && window.Rebuy._status === "initialized" && window.Rebuy.Cart.status && window.Rebuy.Cart.status === "ready";
      
      if (rebuyReady) {
        clearInterval(waitForRebuy);

        // Install fix for Rebuy's invalid cart/update.js key format (422 errors)
        installCartUpdateFix();

        handleCartOperations(window.Rebuy.Cart);

        document.addEventListener('rebuy:cart.change', function (event) {          
          if (isProcessingCartChange) return;
          setTimeout(() => {
            handleCartOperations(window.Rebuy.Cart);
          }, 100);
        });
      }
    }
  }, 200);
});

function handleCartOperations(cart) {
  if (isProcessingCartChange) return;

  isProcessingCartChange = true;
  
  try {
    const cartDetails = cart.getCart();

    // Bundle sync
    const itemsToRemove = [];
    const itemsToUpdate = [];
    cartDetails.items.forEach(item => {
      if (item.properties._racquet_bundle_id) {
        const bundleId = item.properties._racquet_bundle_id;
        if (item.properties.Stringing && item.properties.Stringing === 'Strung') {
          const itemQuantity = item.quantity;
          cartDetails.items.forEach(lineItem => {
            if (lineItem.properties._racquet_bundle_id === bundleId && !lineItem.properties.Stringing && lineItem.quantity !== itemQuantity) {
              itemsToUpdate.push({ id: lineItem.key, quantity: itemQuantity });
            }
          });
        } else {
          const racquet = cartDetails.items.find(lineItem => lineItem.properties._racquet_bundle_id === bundleId && lineItem.properties.Stringing === 'Strung');
          if (!racquet) itemsToRemove.push(item);
        }
      }
    });

    const operations = [];

    if (itemsToRemove.length > 0) {
      itemsToRemove.forEach(item => {
        operations.push(new Promise((resolve) => { cart.removeItem(item, resolve); }));
      });
    }
  
    if (itemsToUpdate.length > 0) {
      itemsToUpdate.forEach(item => {
        operations.push(new Promise((resolve) => { cart.changeItem(item, resolve); }));
      });
    }

    // Demo fee logic
    if (document.querySelector('.extra-product')) {
      const TRIGGER_TAG = document.querySelector('.extra-product').dataset.triggerProductTag;
      const TARGET_VARIANT_ID = +document.querySelector('.extra-product').dataset.extraProduct;

      // Count items that have tags populated
      const itemsWithTags = cartDetails.items.filter(item => {
        const tags = item.product?.tags;
        return tags && (typeof tags === 'string' ? tags.length > 0 : tags.length > 0);
      });

      // Only evaluate demo fee logic if at least some items have tags loaded.
      // This prevents a false "no trigger found" when Rebuy hasn't populated tags yet,
      // which would incorrectly remove the fee.
      const tagsAreLoaded = itemsWithTags.length > 0 || cartDetails.items.length === 0;

      const triggerFound = tagsAreLoaded && cartDetails.items.some(item => {
        const productTags = item.product?.tags || "";
        const tagsStr = Array.isArray(productTags) ? productTags.join(',') : productTags;
        return tagsStr.toLowerCase().includes(TRIGGER_TAG.toLowerCase());
      });

      const targetInCart = cartDetails.items.find(item => item.variant_id === TARGET_VARIANT_ID);

      if (triggerFound && !targetInCart) {
        // Demo racquet(s) present, fee missing — add it
        operations.push(new Promise((resolve) => { cart.addItem({ id: TARGET_VARIANT_ID, quantity: 1 }, resolve); }));
      } else if (tagsAreLoaded && !triggerFound && targetInCart) {
        // Tags are confirmed loaded, no demo racquets found — safe to remove fee
        operations.push(new Promise((resolve) => { cart.removeItem(targetInCart, resolve); }));
      }
      // If !tagsAreLoaded: do nothing — don't add or remove, wait for next cart.change event
    }

    if (operations.length > 0) {
      Promise.all(operations).then(() => {
        setTimeout(() => {
          isProcessingCartChange = false;
          enableCartCheckout();
        }, 500);
      }).catch((error) => {
        console.error("Error in cart operations:", error);
        isProcessingCartChange = false;
        enableCartCheckout();
      });
    } else {
      setTimeout(() => {
        isProcessingCartChange = false;
        enableCartCheckout();
      }, 500);
    }

  } catch (error) {
    console.error("Error accessing Rebuy cart:", error);
    isProcessingCartChange = false;
    enableCartCheckout();
  }
}